import React, { useContext, useEffect, useRef, useState } from "react";
import useDebounce from "../useDebounce";
import "./CommonCityStateDropdown.css"; // optional styling
import { UserContext } from "context";
import { IoIosArrowDown ,IoIosArrowUp} from "react-icons/io";
import UniqueId from "../UniqueId";


const CommonCityStateDropdown = ({
    label = "Select Item",
    fetchData,
    onChange,
    selectedItem = null,
    pageSize = 10,
    disabled = false,
    error = false,
    errorMessage = "",
    isAddButton = false,
    addButtonAction = (e) => { },
    withState=true,
    placeholder
}) => {
    const {
        masterData,

    } = useContext(UserContext);
    const [search, setSearch] = useState("");
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [items, setItems] = useState([]);
    const [displayedItems, setDisplayedItems] = useState([]);
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const [isLoadingMore, setIsLoadingMore] = useState(false);
    const [selected, setSelected] = useState(selectedItem);
    const debouncedSearch = useDebounce(search, 500);
    const containerRef = useRef(null);
     const generateUniqueId = UniqueId('user');  

    useEffect(() => {
        setSelected(selectedItem);
    }, [selectedItem]);

    useEffect(() => {
        if (debouncedSearch !== "") {
            loadItems(true, debouncedSearch, 1);
        } else {
            // If search is cleared, fetch from start
            loadItems(true, "", 1);
        }
    }, [debouncedSearch]);
    

    const loadItems = async (reset = false, query = search, nextPage = 1) => {
        if (!reset) setIsLoadingMore(true);
    
        try {
            const response = await fetchData(query, nextPage, pageSize);
            const newItems = response.items || [];
            const total = response.total || 0;
    
            if (reset) {
                // Replace previous items completely
                setItems(newItems);
                setDisplayedItems(newItems);
                setPage(1);
            } else {
                // Append only during scroll
                setItems(prev => [...prev, ...newItems]);
                setDisplayedItems(prev => [...prev, ...newItems]);
                setPage(nextPage);
            }
    
            setHasMore((reset ? newItems.length : (page * pageSize + newItems.length)) < total);
        } finally {
            setIsLoadingMore(false);
        }
    };

    const loadMore = () => {
        if (hasMore && !isLoadingMore) {
            const nextPage = page + 1;
            loadItems(false, search, nextPage);
        }
    };

    const handleScroll = () => {
        const el = containerRef.current?.querySelector(".dropdown-list");
        if (el && el.scrollTop + el.clientHeight >= el.scrollHeight - 10) {
            loadMore();
        }
    };

    const handleSelect = (item) => {
        if (disabled) return;
        // withState &&  setSelected(item);
        setDropdownOpen(false);
        onChange && onChange(item);
    };

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (containerRef.current && !containerRef.current.contains(e.target)) {
                setDropdownOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);
    

    return (
        <div ref={containerRef} style={{ position: "relative", width: "100%" }}>
            <div onClick={() => !disabled && setDropdownOpen(!dropdownOpen)}
                style={{
                    border: error ? "1px solid red" : "1px solid #ccc",
                    padding: "10px",
                    borderRadius: 4,
                    cursor: disabled ? "not-allowed" : "pointer",
                    backgroundColor: disabled ? "#f2f2f2" : "#fff",
                }}>
                <label
                    style={{
                        position: "absolute",
                        top: dropdownOpen || selected?.name ? -0 : "50%",
                        left: 6,
                        fontSize: dropdownOpen || selected?.name ? 12 : 14,
                        color: "#666",
                        background: "#fff",
                        padding: dropdownOpen || selected?.name?"0 4px":"0 100px 0px 5px",
                        
                        transform: "translateY(-50%)",
                        transition: "all 0.2s ease",
                        pointerEvents: "none",
                    }}
                >
                    {label}
                </label>
                <span style={{
                    color: selected?.name ? "#000" : "#888",
                    fontSize: 14
                }}>
                   {selected?.name ? `${selected.name}, ${selected.stateName}` : placeholder}
                   
                </span>
                <span style={{ float: "right" }}>{dropdownOpen ? <IoIosArrowUp/>  : <IoIosArrowDown/>}</span>
            </div>

            {dropdownOpen && !disabled && (
                <div
                    className="dropdown-list"
                    style={{
                        position: "absolute",
                        top: "100%",
                        width: "100%",
                        maxHeight: 250,
                        overflowY: "auto",
                        background: "#fff",
                        border: "1px solid #ccc",
                        borderRadius: 4,
                        zIndex: 1000,
                        marginTop: 4,
                        display: "flex",
                        flexDirection: "column",
                    }}
                    onScroll={handleScroll}
                >
                    <div className="__searchIn_multiBx">
                        <input
                            type="text"
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            placeholder="Search..."
                            style={{
                                width: "100%",
                                padding: "8px",
                                boxSizing: "border-box",
                                borderBottom: "1px solid #ccc",
                            }}
                            autoFocus
                        />
                    </div>
                    <div className="__otr_checkBx_fl">
                      
                        {displayedItems.map((item) =>{ 
                            const uniqId = generateUniqueId(item?.value);
                            // (
                            return <div
                                // key={`${item._id}_${item?.latitude}_${item?.longitude}`}
                                key={uniqId}
                                onClick={() => handleSelect(item)}
                                style={{
                                    padding: "8px 12px",
                                    backgroundColor: selected?.value === item.value ? "#f0f8ff" : "#fff",
                                    cursor: "pointer",
                                    display: "flex",
                                    alignItems: "center",   
                                    gap: 10,
                                    borderBottom: "1px solid #e8eaed"
                                }}
                            >
                                { `${item?.name}, ${item?.stateName}`}

                               
                            </div>
                        // )
                        })}
                    </div>

                    {isLoadingMore && (
                        <div style={{ padding: 8, textAlign: "center", fontSize: 12 }}>
                            Loading...
                        </div>
                    )}

                    {/* {!hasMore || displayedItems.length != 0 || !isLoadingMore && (
                        <div style={{ padding: 8, textAlign: "center", fontSize: 12 }}>
                            No more items
                        </div>
                    )} */}

                    {displayedItems.length === 0 && !isLoadingMore && (
                        <div style={{ padding: 8, textAlign: "center", fontSize: 12 }}>
                            No Data
                        </div>
                    )}
                    {isAddButton && <div
                        onClick={addButtonAction}
                        style={{
                            borderTop: "1px solid #ccc",
                            background: "#fff",
                            padding: 5,
                            position: "sticky",
                            bottom: 0,
                            zIndex: 2,
                        }}

                    >
                        <button
                            className="_addNew_cdmBtn"

                            onClick={addButtonAction}
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                viewBox="0 0 18 18"
                                fill="none"
                            >
                                <path
                                    d="M8.61539 0C6.33902 0.0276205 4.16368 0.944178 2.55393 2.55393C0.944178 4.16368 0.0276205 6.33902 0 8.61539C0.0276205 10.8917 0.944178 13.0671 2.55393 14.6768C4.16368 16.2866 6.33902 17.2031 8.61539 17.2308C10.8917 17.2031 13.0671 16.2866 14.6768 14.6768C16.2866 13.0671 17.2031 10.8917 17.2308 8.61539C17.2031 6.33902 16.2866 4.16368 14.6768 2.55393C13.0671 0.944178 10.8917 0.0276205 8.61539 0ZM13.5385 9.23077H9.23077V13.5385H8V9.23077H3.69231V8H8V3.69231H9.23077V8H13.5385V9.23077Z"
                                    fill="#1956F6"
                                />
                            </svg>
                            Add New
                        </button>
                    </div>}
                </div>
            )}

            {error && errorMessage && (
                <div style={{ color: "red", fontSize: 12, marginTop: 4 ,fontWeight:500}}>
                    {errorMessage}
                </div>
            )}
        </div>
    );
};

export default CommonCityStateDropdown;